import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from "classnames";
import { Container } from 'react-bootstrap'
import Skeleton from '../../../Common/Skeleton/Skeleton'
import BookingIdSkeletonCard from '../BookingIdSkeletonCard/BookingIdSkeletonCard';
import OrderStatusSkeleton from '../OrderStatusSkeleton/OrderStatusSkeleton'
import s from './ViewTrackingSkeleton.css'


function ViewTrackingSkeleton() {
    return (
        <>
            <Skeleton className={s.goBackSkeleton} />
            <div className={s.viewTrackingSkeletonContainer}>
                <div className={s.viewTrackingSkeletonMapContainer}>
                    <div className={cx(s.viewTrackProviderDetailsSkeletonBox, 'viewTrackProviderDetailsBoxRtl')}>
                        <div className={s.viewTrackProviderDetailsSkeleton}>
                            <Skeleton className={s.viewTrackProviderDetailsImgSkeleton} />
                            <div className={s.providerCardDetailsSkeletonInfoContainer}>
                                <div className={s.providerCardDetailsSkeletonHeadingBox}>
                                    <Skeleton className={s.providerCardInfoTitleSkeleton} />
                                    <Skeleton className={s.providerCardInfoDesSkeleton} />
                                </div>
                                <div className={s.providerCardDetailsSkeletonIconContainer}>
                                    <Skeleton className={s.providerCardDetailsSkeletonIcon} />
                                    <Skeleton className={s.providerCardDetailsSkeletonIcon} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={s.viewTrackingSkeletonSkeletonRsContainer}>
                    <BookingIdSkeletonCard />
                    <OrderStatusSkeleton />
                </div>
            </div>
        </>
    )
}

export default withStyles(s)(ViewTrackingSkeleton);
